<div class="editable-content-container" *ngIf="hasContent()">
  <mat-card class="editable-content-card">
    <mat-card-header *ngIf="content?.title">
      <mat-card-title>{{ content?.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="content-items">
        <ng-container *ngFor="let item of content?.items">
          <!-- Text content -->
          <div *ngIf="item.type === 'text'" class="content-item text-item">
            <p [innerHTML]="sanitizeHtml(item.content)"></p>
          </div>

          <!-- Link content -->
          <div
            *ngIf="item.type === 'link' && item.url"
            class="content-item link-item"
          >
            <mat-icon class="item-icon">{{ getIcon(item) }}</mat-icon>
            <a [href]="item.url" target="_blank" rel="noopener noreferrer">
              {{ item.content }}
            </a>
          </div>

          <!-- File download content -->
          <div
            *ngIf="item.type === 'file' && item.url"
            class="content-item file-item"
          >
            <mat-icon class="item-icon">{{ getIcon(item) }}</mat-icon>
            <a
              [href]="item.url"
              [download]="item.fileName || true"
              target="_blank"
            >
              {{ item.content }}
            </a>
            <span *ngIf="item.fileName" class="file-name"
              >({{ item.fileName }})</span
            >
          </div>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>
</div>
